<template lang="html">
    <div class="home-index">
        <van-tabs sticky title-active-color="#0091AC" swipeable animated background="#F5F6F7">
            <van-tab title="我的预约课程"  title-style="font-size:0.4rem;">
                <div class="list-caontainer">
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <van-list
                                v-model="loading"
                                :finished="finished"
                                @load="onLoad"
                                finished-text="没有更多了">
                            <van-cell v-for="item in unStartCourse" :key="item.id" >
                                <van-card class="list-card">
                                    <template #thumb style="border-radius:0px;">
                                        <van-image  width="16vw" fit="cover"  :src="item.courseImgUrl.indexOf(',')>0 ? item.courseImgUrl.substring(0, item.courseImgUrl.indexOf(',')) : item.courseImgUrl" />
                                    </template>
                                    <template #desc>
                                        <div style="font-size: 0.4rem;font-weight: bold;"> {{ item.courseName }}
                                            <div style="float:right;">
                                                <van-button v-if="item.courseStatus == 0" type="warm" size="mini">等待直播</van-button>
                                                <van-button v-if="item.courseStatus == 1" type="primary" size="mini"  @click="enterLive(item.courseLink)">进入直播</van-button>
                                                <van-button v-if="item.courseStatus == 2" type="danger" size="mini">已结束</van-button>
                                            </div>
                                        </div>
                                        <div style="font-size: 0.3rem; color: #888;"> 开始时间：{{ item.courseStartTime }} </div>
                                        <div style="font-size: 0.3rem; color: #888;"> 结束时间：{{ item.courseEndTime }} </div>
                                    </template>
                                </van-card>
                            </van-cell>
                        </van-list>
                    </van-pull-refresh>
                </div>
            </van-tab>
        </van-tabs>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                count: 0,
                activeNames: ['1'],
                finished: false,
                isLoading: false,
                page: {
                    current: 1,
                    size: 6
                },
                divShow: 'consultant',
                show: true,
                searchKey:"",
                latestData: [],
                categoryData: [],
                rejectCourseList: [],
                finishedCourse: [],
                unStartCourse: [],
                loading: false,
            }
        },
        created() {
        },
        watch: {
            searchKey(val, oldVal){
                console.log('val:  ',val, '  oldVal ', oldVal);
                //==== this.searchLatestCourse();
            },
        },
        mounted() {
            //this.getMobileBannerList();
            this.getUnStartCourse();
        },
        methods: {
            getUnStartCourse(){
                this.$api.course.sendPage({
                    ...this.page,
                    processIsFinished: 'finished'
                }).then((res) => {
                    this.isLoading = false;
                    this.loading = false;
                    console.log("查询数据："+res);
                    this.unStartCourse = res.data.records;
                    this.finished = true;
                })
            },
            onRefresh() {
                if (!this.finished){
                    this.page.current = this.page.current + 1;
                    this.getUnStartCourse();
                }
            },
            enterLive(courseLink){
                window.location.href = courseLink;
                //====进入直播跳转
            },
            onLoad(){

            }
        }
    }
</script>

<style lang="less" scoped>

    .home-swipe {
        background-color:#fff;
        img {
            width: 100vw;
        }
    }
    .custom-title{
        margin-top:10px;
        font-size:14px;
    }
    .new-course-image{
        width:100%;
        max-height: 104px;
        min-height: 104px;
    }
    .course-title,.course-subtitle,.course-price{ display:block;font-size:16px; padding:3px 0;font-weight:bold;}
    .course-title{ color:000; }
    .course-subtitle{color: #00000073; font-size:14px;}
    .course-price{color: #e85728;}
    .van-search__content{ background-color: #fff; border:1px solid #eee;  }
    .course-item .van-grid-item__content{ height:auto; padding-bottom: 5px; padding-top: 10px;}
</style>
